import { useMutation } from '@apollo/client';
import { Button, Col, Modal, Row } from 'antd';
import { upperCase } from 'lodash';
import React from 'react';
import { REMOVE_ITEM_FROM_CART } from './graphql/Mutations';

function RemoveItemModal({
  isModalOpen,
  setIsModalOpen,
  refetch,
  selectedRecord,
  setSelectedRecord,
}) {
  const [removeItemFromCart, { loading }] = useMutation(REMOVE_ITEM_FROM_CART, {
    onCompleted() {
      setIsModalOpen(false);
      setSelectedRecord();
      refetch();
    },
    onError() {},
  });

  const handleDelete = () => {
    removeItemFromCart({
      variables: {
        where: {
          id: selectedRecord,
        },
      },
    });
  };

  return (
    <div id="delete-categories-modal">
      <Modal
        centered
        closable={false}
        title={<h3 className="m-0 mb-10">{upperCase('Remove Item')}</h3>}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        open={isModalOpen}
        width={576}
      >
        <p className="mb-16 mt-10">
          Are you sure you want to remove this item from your cart?
        </p>
        <Row gutter={10}>
          <Col span={12}>
            <Button
              disabled={loading}
              onClick={() => {
                setIsModalOpen(false);
                setSelectedRecord();
              }}
              className="full-width font-600 submit-btn"
            >
              Discard
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              className="full-width font-600 submit-btn"
              loading={loading}
              onClick={() => handleDelete()}
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

export default RemoveItemModal;
